
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    /* eslint-disable react/no-array-index-key */
/* eslint-disable no-param-reassign  */
import React from 'react';
import PropTypes from 'prop-types';
import FactFileThumbs from '@components/FactFileThumbs';
import s from './RelatedEntries.module.scss';
const propTypes = {
    content: PropTypes.array.isRequired
};
const RelatedEntries = ({ content }) => {
    return (<div className={s.root}>
      <div className={s.heading}>Related Entries</div>
      <div className={s.entries}>
        <FactFileThumbs thumbs={content}/>
      </div>
    </div>);
};
RelatedEntries.propTypes = propTypes;
export default RelatedEntries;

    async function __Next_Translate__getStaticProps__195ca0caf3a__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//FactFile/components/RelatedEntries/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0caf3a__ as getStaticProps }
  